var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgShoppingCart = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25524 22.9998C6.83342 22.9998 5.6808 21.8471 5.6808 20.4253C5.6808 19.0035 6.83342 17.8509 8.25524 17.8509C9.67706 17.8509 10.8297 19.0035 10.8297 20.4253C10.8297 21.8471 9.67706 22.9998 8.25524 22.9998ZM8.25524 21.5955C8.90152 21.5955 9.42544 21.0716 9.42544 20.4253C9.42544 19.779 8.90152 19.2551 8.25524 19.2551C7.60896 19.2551 7.08504 19.779 7.08504 20.4253C7.08504 21.0716 7.60896 21.5955 8.25524 21.5955ZM19.4892 22.9998C18.0673 22.9998 16.9147 21.8471 16.9147 20.4253C16.9147 19.0035 18.0673 17.8509 19.4892 17.8509C20.911 17.8509 22.0636 19.0035 22.0636 20.4253C22.0636 21.8471 20.911 22.9998 19.4892 22.9998ZM19.4892 21.5955C20.1354 21.5955 20.6594 21.0716 20.6594 20.4253C20.6594 19.779 20.1354 19.2551 19.4892 19.2551C18.8429 19.2551 18.319 19.779 18.319 20.4253C18.319 21.0716 18.8429 21.5955 19.4892 21.5955ZM6.68032 5.6808H22.2976C22.7408 5.6808 23.0731 6.08626 22.9861 6.52078L21.4136 14.3741C21.1706 15.5972 20.0859 16.4704 18.8526 16.4466L8.96332 16.4466C7.66256 16.4576 6.55793 15.4966 6.38895 14.2074L4.96591 3.42231C4.88963 2.84049 4.39422 2.40513 3.80848 2.40424H1.70212C1.31435 2.40424 1 2.08989 1 1.70212C1 1.31435 1.31435 1 1.70212 1L3.80954 1C5.10051 1.00196 6.19041 1.95975 6.35816 3.23919L6.68032 5.6808ZM7.78121 14.0244C7.85805 14.6106 8.36015 15.0474 8.95736 15.0424L18.866 15.0425C19.4328 15.0534 19.9258 14.6565 20.0364 14.0994L21.441 7.08504H6.8656L7.78121 14.0244Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgShoppingCart;